
import 'radar-sdk-js/dist/radar.css'
import Radar from '~/node_modules/radar-sdk-js'
import maplibregl from 'maplibre-gl'
import { mapState } from 'vuex'

import AddressInfo from './StoreDetails/AddressInfo.vue'
import PhoneInfo from './StoreDetails/PhoneInfo.vue'

export default {
  name: 'Map',
  components: {
    AddressInfo,
    PhoneInfo
  },
  props: {
    center: Array,
    locations: Array,
    location: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      map: false,
      activeLocation: null,
    }
  },
  computed: {
    ...mapState(['appInfo']),
    popup() {
      if (document.querySelector('.radar-map-popup')) {
        return document.querySelector('.radar-map-popup').innerHTML
      }
    },
    appRadar() {
      return this.appInfo['radar_map']
    }
  },
  methods: {
    initialize() {
      const radarKey = process.env.RADAR_KEY
      if (!radarKey) {
        this.$utils.log('RadarMap - RADAR_KEY is missing')
        return
      }

      Radar.initialize(radarKey)
      // prevent duplicate maps from rendering over each other
      if (this.map) {
        this.map.remove()
      }
      this.map = Radar.ui.map({
        container: 'map', center:
          [this.location.lng, this.location.lat],
        zoom: 13
      })

      this.map.setStyle(this.appRadar.style)
    },
    zoomInLocation() {
      this.map?.setZoom(this.appRadar['single_result_zoom'] || this.appRadar['results_zoom'])
      setTimeout(() => this.map?.setCenter([this.location.lng, this.location.lat]), 250)
    },
    addMarker() {
      const marker = document.createElement('div')
      marker.className = 'marker'
      marker.style.backgroundImage = 'url('+this.appRadar.marker.url+')'
      marker.style.width = this.appRadar.marker.width
      marker.style.height = this.appRadar.marker.height
      marker.style.backgroundSize = this.appRadar.marker['background_size']
      marker.style.backgroundRepeat = this.appRadar.marker['background_repeat']
      marker.addEventListener('click', () => {
        this.setActiveLocation(this.location)
      })
      new maplibregl.Marker(marker)
        .setLngLat([this.location.lng, this.location.lat])
        .addTo(this.map)
      this.zoomInLocation()
    },
  },
  mounted() {
    setTimeout(() => {
      this.initialize()

      if (this.location) {
        this.addMarker()
      }
    }, 200)
  },
}
